import React from 'react';
import { Youtube, Mail, Instagram, Video } from 'lucide-react';

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-black border-t border-purple-900/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Top section with logo and text */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <div>
            <button 
              onClick={scrollToTop}
              className="flex items-center space-x-3 group mb-6"
            >
              <img 
                src="/logo.png" 
                alt="Logo"
                className="w-[35%] object-contain transform group-hover:scale-110 transition-transform duration-300"
              />
            </button>
            <p className="text-gray-400 mb-6 max-w-md">
              Votre partenaire de confiance pour réussir dans le trading. Rejoignez notre communauté d'experts et évoluez vers le succès.
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Navigation</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-400 hover:text-purple-400 transition-colors">Accueil</a></li>
              <li><a href="#" className="text-gray-400 hover:text-purple-400 transition-colors">Services</a></li>
              <li><a href="#" className="text-gray-400 hover:text-purple-400 transition-colors">Formation</a></li>
              <li><a href="#" className="text-gray-400 hover:text-purple-400 transition-colors">Communauté</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom section */}
        <div className="border-t border-purple-900/50 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © {new Date().getFullYear()} Tous droits réservés.
            </p>
            <button onClick={scrollToTop} className="text-gray-400 hover:text-purple-400 transition-colors text-sm">
              Retour en haut ↑
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
